import { CustomBottomBar, CustomPageTitle, MinimalStepper } from '@components';
import { Button, Checkbox, Container, Spacing, Typography } from '@design-system';
import React from 'react';
import { BiSolidChat } from 'react-icons/bi';
import { RiArrowGoBackLine } from 'react-icons/ri';
import SignatureCanvas from 'react-signature-canvas';
import './CauseriesTalkEmargementPage.scss';
import { useCauseriesTalkEmargementPageVM } from './useCauseriesTalkEmargementPageVM';
import { UserDropdown } from '@components/UserDropdown/UserDropDown';
import { OperatorDropdown } from '@components/OperatorDropdown/OperatorDropDown';


export const CauseriesTalkEmargementPage: React.FC = () => {
    const {
        errorMessage,
        pageTitle,
        isSomeoneElse,
        handleIsSomeoneElseChange,
        signatureCanvasRef,
        handleClearSignature,
        setIsEmpty,
        handleClickSave,
        isDisabled,
        requestUser,
        handleRequestUserChange,
        instructorName,
        handleInstructorNameChange
    } = useCauseriesTalkEmargementPageVM();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    return (
        <div className="causeries-talk-emargement-page">
            {pageTitle && (
                <CustomPageTitle>
                    <Typography intrinsic="h3" iconColor="blue" icon={<BiSolidChat />} iconFilled iconSize={20}>
                        {pageTitle}
                    </Typography>
                </CustomPageTitle>
            )}

            <Container className="emargement-page-header" radius="none" column>
                <Typography intrinsic="h2" className="mb-large-spacing">
                    Emargement
                </Typography>
                <MinimalStepper
                    steps={[
                        { label: 'Les instructions', status: 'completed' },
                        { label: 'Le quizz', status: 'completed' },
                        { label: 'Emargement', status: 'inProgress' }
                    ]}
                />
            </Container>

            <Container>
                <Container className="emargement-page-content" padding="medium large" bordered="grey">
                    <Typography intrinsic="h4" className="mb-large-spacing">
                        Informations
                    </Typography>

                    <div className="mb-large-spacing">
                        <Typography intrinsic="p" color="marine" className="mb-medium-spacing">
                          Causerie sécurité animée par :
                        </Typography>
                        <OperatorDropdown
                            onChangeAction={(operatorId: string) => handleInstructorNameChange(operatorId)}
                            value={instructorName}
                            valueKey="label"
                            canCreate
                        />
                    </div>

                    {/*<Typography intrinsic="h4" className="mb-large-spacing">
                        Signature digitale
                    </Typography>*/}
                    {/*<Typography intrinsic="p" color="marine" className="mb-large-spacing">
                        Veuillez signer le document ci-dessous pour valider votre emargement.
                    </Typography>*/}

                    <Typography intrinsic="p" color="grey">
                        En appuyant sur « Signer », vous attestez avoir pris connaissance des causeries de sécurité qui vous ont été
                        présentées, en avoir compris le contenu et avoir validé vos connaissances à travers le quiz associé.
                    </Typography>
                </Container>

                <Container className="emargement-page-content mt-medium-spacing" padding="medium large" bordered="grey">
                    <Checkbox
                        checked={isSomeoneElse}
                        onChange={handleIsSomeoneElseChange}
                        label="Cette causerie a été réalisée par quelqu'un d'autre que moi"
                    />
                    {isSomeoneElse && (
                        <div className="mt-medium-spacing">
                            <UserDropdown
                                onChangeAction={(value: string) => handleRequestUserChange(value)}
                                value={requestUser}
                                valueKey="label"
                                canCreate={true}
                            />

                            <SignatureCanvas
                                throttle={24}
                                velocityFilterWeight={1}
                                penColor="black"
                                canvasProps={{
                                    className: 'sigCanvas'
                                }}
                                onEnd={() => setIsEmpty(false)}
                                ref={signatureCanvasRef}
                            />
                            <Spacing />
                            <div className="buttons">
                                <Button
                                    icon={<RiArrowGoBackLine />}
                                    iconSize={25}
                                    onClick={handleClearSignature}
                                    iconColor="green"
                                    variant="secondary"
                                    color="green"
                                    className="refresh-signature-button"
                                >
                                    <></>
                                </Button>
                            </div>
                        </div>
                    )}
                </Container>
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="green" onClick={handleClickSave} size="fullwidth" disabled={isDisabled}>
                    <Typography intrinsic="h4">Signer</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
